import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../hooks/useAdminAuth";
import AdminPanel from "./admin/AdminPanel";

const STAFF_ROLES = ["employee", "admin", "superadmin"];

export default function AdminProtectedRoute() {
    const { user, loading, logout, updateUser } = useAdminAuth();

    if (loading) {
        return (
            <div style={{ minHeight: "100vh", background: "#0f1117", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ width: 36, height: 36, border: "3px solid #2e3352", borderTopColor: "#6c63ff", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />
            </div>
        );
    }

    if (!user || !STAFF_ROLES.includes(user.role)) {
        return <Navigate to="/login" replace />;
    }

    // Pass user/logout down — AdminPanel must NOT call useAdminAuth itself
    return <AdminPanel user={user} logout={logout} updateUser={updateUser} />;
}